<script>
  import { createEventDispatcher } from "svelte";
  import { tooltip } from "svelte-utilities";

  import ImageIcon from "@local/assets/icons/image.svg";
  import ShapeIcon from "@local/assets/icons/shape.svg";
  import ShapeImageIcon from "@local/assets/icons/shape-image.svg";

  export let item;

  const dispatch = createEventDispatcher();

  $: val = getItemDrawingValue(item);

  function getItemDrawingValue(item) {
    if (!item.replace_with_drawing) return "shape";
    if (item.show_drawing_overlay) return "both";
    return "drawing";
  }

  function updateItemDrawingValue(val) {
    if (val === "shape") {
      dispatch("updateItem", {
        id: item.id,
        diff: { replace_with_drawing: false, show_drawing_overlay: false },
      });
    } else if (val === "drawing") {
      dispatch("updateItem", {
        id: item.id,
        diff: { replace_with_drawing: true, show_drawing_overlay: false },
      });
    } else if (val === "both") {
      dispatch("updateItem", {
        id: item.id,
        diff: { replace_with_drawing: true, show_drawing_overlay: true },
      });
    }
  }
</script>

<div class="absolute left-0 top-0 flex flex-col items-center p-2">
  <button
    class:active={val === "drawing"}
    on:click|stopPropagation={() => updateItemDrawingValue("drawing")}
    use:tooltip={{ text: "Show Clip" }}>
    <ImageIcon />
  </button>
  <button
    class:active={val === "shape"}
    on:click|stopPropagation={() => updateItemDrawingValue("shape")}
    use:tooltip={{ text: "Show Shape" }}>
    <ShapeIcon />
  </button>
  <button
    class:active={val === "both"}
    on:click|stopPropagation={() => updateItemDrawingValue("both")}
    use:tooltip={{ text: "Shape + Clip" }}>
    <ShapeImageIcon />
  </button>
</div>

<style>
  button {
    @apply p-1 rounded opacity-30;

    &:hover {
      @apply bg-gray-200;
    }

    &.active {
      @apply opacity-100 bg-gray-200;
    }
  }
</style>
